module.exports = __webpack_public_path__ + "public/hws/images/language@red.png";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/language@red.png
// module id = 331
// module chunks = 0